/**
 * Created by Ning Jiang on 2021-06-16.
 */
import {WinPresentationController} from "../WinPresentationController";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {Oktoberfest} from "../../Oktoberfest";
import {OktoberfestGameConfig} from "../../OktoberfestGameConfig";
import {IBetLineWinData, IBetWayWinData} from "../../server/data/IOktoberfestData";
import {OktoberfestSymbolState} from "../../symbol/OktoberfestSymbolConfig";

export class NoWinSymbolsController extends WinPresentationController {

    constructor() {
        super("NoWinSymbolsController", false);
    }

    protected hasWin(): boolean {
        return Oktoberfest.model.parsedGameData.betWins?.length > 0 || Oktoberfest.model.parsedGameData.freespinTriggeredThisSpin;
    }

    protected async createWinAnimation(): Promise<void> {
        const symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(OktoberfestGameConfig.REELS_NUM, () => {
            return ArrayHelper.initArrayWithValues<boolean>(3, () => false)
        });
        const gameData = Oktoberfest.model.parsedGameData;
        switch (OktoberfestGameConfig.BET_WIN_MODE) {
            case BetWinMode.BET_LINE:
                (<IBetLineWinData[]>gameData.betWins).forEach(winLine => {
                    for (let reelId: number = 0; reelId < winLine.nrOfSymbols; reelId++) {
                        const symbolId: number = winLine.betLine[reelId];
                        symbolWinStates[reelId][symbolId] = true;
                    }
                });
                break;
            case BetWinMode.BET_WAY:
                (<IBetWayWinData[]>gameData.betWins).forEach(winWay => {
                    winWay.reelWinPositions.forEach((reelWin, reelId) => {
                        reelWin.forEach((symWin, symId) => {
                            if (symWin) {
                                symbolWinStates[reelId][symId] = true;
                            }
                        });
                    });
                });
                break;
            default:
                debugger;
                throw new Error(`NoWinSymbolsController, wrong BetWinMode in config.`);
        }
        if (gameData.freespinTriggeredThisSpin) {
            gameData.scatterPositions?.forEach((symId, reelId) => {
                if (symId > -1) {
                    symbolWinStates[reelId][symId] = true;
                }
            });
        }

        // #756
        symbolWinStates.forEach((reelWin, reelId) => {
            reelWin.forEach((w, symId) => {
                let symbol = Oktoberfest.reels[reelId].getSymbol(symId);
                if (w && symbol.stackedSymbolName.isStacked) {
                    let index = symId - 1;
                    while (index >= 0) {
                        let prevSym = Oktoberfest.reels[reelId].getSymbol(index);
                        if (prevSym.stackedSymbolName.isStacked) {
                            symbolWinStates[reelId][index] = true;
                        }
                        index--;
                    }
                    index = symId + 1;
                    while (index < reelWin.length) {
                        let prevSym = Oktoberfest.reels[reelId].getSymbol(index);
                        if (prevSym.stackedSymbolName.isStacked) {
                            symbolWinStates[reelId][index] = true;
                        }
                        index++;
                    }
                }
            });
        });

        const promises: Promise<any>[] = [];
        console.log("Win State: ", symbolWinStates);
        symbolWinStates.forEach((reelWin, reelId) => {
            reelWin.forEach((w, symId) => {
                if (!w) {
                    promises.push(Promise.resolve(Oktoberfest.reels[reelId].getSymbol(symId).getStateAnimation(
                        OktoberfestSymbolState.NO_WIN,
                        {duration: 0.1, alpha: 1},
                        {duration: 0.1, alpha: 0}
                    )));
                }
            });
        });

        await Promise.all(promises);
    }
}
